import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const Start = () => {
	const { t } = useTranslation();
	return (
		<div className='textContentContainer'>
			<h1>{t('startPage.Title')}</h1>
			<div>
				<p>{t('startPage.p1')}</p>
				<p>{t('startPage.p2')}</p>
				<p>{t('startPage.p3')}</p>
				<p>{t('startPage.p4')}</p>
			</div>
		</div>	
	);
}
